import * as runtime from '@/api/runtime'
import {
  BatchReserveUserListRequest,
  BatchReserveUserListRequestToJSON,
  BatchStatisticsPageLoadRequest,
  BatchStatisticsPageLoadRequestToJSON
} from '@/api/models/batch'
import {
  BatchReserveUserListCondition,
  BatchReserveUserListConditionFromJSON
} from '@/api/models/batch/BatchReserveUserListCondition'

/**
 * 帳票作成
 */
export class BatchReserveUserListApi extends runtime.BaseAPI {
  async return(request: BatchReserveUserListRequest): Promise<number> {
    const response = await this.requestPost(
      `/batch/reserve/reserve-user-list`,
      BatchReserveUserListRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      Number(jsonValue.request_id)
    ).value()
  }

  async getInitialCondition(
    request: BatchStatisticsPageLoadRequest
  ): Promise<BatchReserveUserListCondition> {
    const response = await this.requestGet(
      `/batch/statistics/search_initial_condition`,
      BatchStatisticsPageLoadRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      BatchReserveUserListConditionFromJSON(jsonValue)
    ).value()
  }
}
